var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.837 4H5.6109C4.4399 4 3.4906 4.94507 3.4906 6.11088V17.8891C3.4906 19.0549 4.4399 20 5.6109 20H16.837C18.008 20 18.9573 19.0549 18.9573 17.8891V6.11088C18.9573 4.94507 18.008 4 16.837 4Z",
    fill: "url(#paint0_linear_468_75471)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6926 16.7543L12.0946 17.3807C11.7733 17.458 11.4835 17.169 11.5608 16.8478L12.1854 14.2481C12.2184 14.1103 12.2889 13.9839 12.3891 13.8838L19.9484 6.32734C20.2631 6.01279 20.7727 6.01279 21.0867 6.32734L22.6157 7.8557C22.9303 8.17024 22.9303 8.6797 22.6157 8.99357L15.0557 16.5507C14.9555 16.6508 14.8298 16.7214 14.6919 16.7543H14.6926Z",
    fill: "url(#paint1_linear_468_75471)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9891 17.4406C11.8614 17.4406 11.7376 17.3902 11.6442 17.2967C11.5225 17.1751 11.4741 17.003 11.5138 16.8357L12.1384 14.236C12.1733 14.0895 12.2486 13.9557 12.3549 13.8495L19.9142 6.29308C20.247 5.96106 20.7876 5.96106 21.1197 6.29308L22.6486 7.82144C22.9808 8.15346 22.9808 8.6945 22.6486 9.02652L15.0887 16.5836C14.9824 16.6898 14.8487 16.7644 14.7028 16.8001L12.1048 17.4265C12.0658 17.4359 12.0268 17.4406 11.9884 17.4406H11.9891ZM20.5179 6.13917C20.3243 6.13917 20.13 6.2131 19.9821 6.36029L12.4228 13.9167C12.3287 14.0108 12.2628 14.1291 12.2312 14.2582L11.6065 16.8579C11.5743 16.9923 11.6133 17.1314 11.7114 17.2289C11.8096 17.327 11.9481 17.366 12.0833 17.333L14.6812 16.7066C14.8103 16.6757 14.928 16.6092 15.0221 16.5158L22.5821 8.95864C22.8772 8.66359 22.8772 8.18303 22.5821 7.88798L21.0531 6.35962C20.9052 6.21176 20.7116 6.1385 20.5173 6.1385L20.5179 6.13917Z",
    fill: "url(#paint2_linear_468_75471)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5753 7.73329H6.13934C5.85436 7.73329 5.62396 7.49416 5.62396 7.19996C5.62396 6.90506 5.85504 6.66663 6.13934 6.66663H12.5753C12.8602 6.66663 13.0906 6.90576 13.0906 7.19996C13.0906 7.49486 12.8596 7.73329 12.5753 7.73329Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91344 9.86672H6.13445C5.85218 9.86672 5.62396 9.62759 5.62396 9.33338C5.62396 9.03848 5.85284 8.80005 6.13445 8.80005H9.91344C10.1957 8.80005 10.424 9.03918 10.424 9.33338C10.424 9.62828 10.195 9.86672 9.91344 9.86672Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_75471",
    x1: 3.5,
    y1: 4.5,
    x2: 18.9312,
    y2: 20.0682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D871F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C21CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_468_75471",
    x1: 11.5482,
    y1: 11.7426,
    x2: 22.8517,
    y2: 11.7426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_468_75471",
    x1: 11.5002,
    y1: 11.7426,
    x2: 22.8977,
    y2: 11.7426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorEdit);
export default __webpack_public_path__ + "static/media/color-edit.68368016b5a2e3c3c466c88cf24c508a.svg";
export { ForwardRef as ReactComponent };